import { RootReducer } from '@/types';

export const selectSmsUseCases = (state: RootReducer) =>
  state.shareReducer.enums.smsUseCases;
export const selectVerticalTypes = (state: RootReducer) =>
  state.shareReducer.enums.verticalTypes;
export const selectCountries = (state: RootReducer) =>
  state.shareReducer.enums.countries;
export const selectMnos = (state: RootReducer) => state.shareReducer.enums.mnos;
